import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { ProjectTeamChangeRequest } from '../types';
import { SuccessData } from 'types/api';

type RequestTeamChangeParams = {
  projectId: string;
  team: string;
  justification: string;
};

type AnswerTeamChangeParams = {
  projectId: string;
  approved: boolean;
  justification?: string;
  newOwner?: string;
};

export const projectTeamMutations = getMutations({
  requestTeamChange: {
    action: async (payload: RequestTeamChangeParams): Promise<ProjectTeamChangeRequest> => {
      return executeApiCall({
        path: '/projects/team-change',

        method: 'post',

        payload,
      });
    },
  },

  answerTeamChange: {
    action: async (payload: AnswerTeamChangeParams): Promise<SuccessData> => {
      return executeApiCall({
        path: '/projects/team-change',

        method: 'put',

        payload,
      });
    },
  },
});
